"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5100],{

/***/ 50853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SkeletonImageItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88078);
// @mui


// ----------------------------------------------------------------------
function SkeletonImageItem() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
        item: true,
        xs: 12,
        sm: 6,
        md: 4,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
            container: true,
            spacing: 1,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        variant: "rectangular",
                        width: "100%",
                        sx: {
                            height: 330
                        }
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        variant: "rectangular",
                        width: "100%",
                        sx: {
                            height: 50,
                            borderRadius: 1
                        }
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        variant: "rectangular",
                        width: "100%",
                        sx: {
                            height: 150,
                            borderRadius: 1
                        }
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 96339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "MD": function() { return /* reexport */ SkeletonImage/* default */.Z; },
  "VJ": function() { return /* reexport */ SkeletonPost; },
  "M2": function() { return /* reexport */ SkeletonPostItem; },
  "Ti": function() { return /* reexport */ SkeletonProduct; },
  "JJ": function() { return /* reexport */ SkeletonProductItem; }
});

// UNUSED EXPORTS: SkeletonConversationItem, SkeletonKanbanColumn, SkeletonMailSidebarItem, SkeletonMap

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/skeleton/SkeletonMap.tsx
// @mui



// ----------------------------------------------------------------------
function SkeletonMap() {
    return /*#__PURE__*/ _jsx(Stack, {
        spacing: 8,
        children: _to_consumable_array(Array(5)).map(function(_, index) {
            return /*#__PURE__*/ _jsx(Skeleton, {
                variant: "rectangular",
                sx: {
                    width: 1,
                    height: 560,
                    borderRadius: 2
                }
            }, index);
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Skeleton/Skeleton.js + 2 modules
var Skeleton_Skeleton = __webpack_require__(88078);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box_Box = __webpack_require__(36822);
;// CONCATENATED MODULE: ./src/components/skeleton/SkeletonPost.tsx
// @mui


// ----------------------------------------------------------------------
function SkeletonPost() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                width: "100%",
                height: 560,
                variant: "rectangular",
                sx: {
                    borderRadius: 2
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    mt: 3,
                    display: "flex",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "circular",
                        width: 64,
                        height: 64
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: {
                            flexGrow: 1,
                            ml: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "text",
                                height: 20
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "text",
                                height: 20
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "text",
                                height: 20
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
;// CONCATENATED MODULE: ./src/components/skeleton/SkeletonProduct.tsx
// @mui


// ----------------------------------------------------------------------
function SkeletonProduct() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        spacing: 3,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                md: 6,
                lg: 7,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "rectangular",
                    width: "100%",
                    sx: {
                        paddingTop: "100%",
                        borderRadius: 2
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                md: 6,
                lg: 5,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "circular",
                        width: 80,
                        height: 80
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "text",
                        height: 240
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "text",
                        height: 40
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "text",
                        height: 40
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "text",
                        height: 40
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/skeleton/SkeletonPostItem.tsx
// @mui


// ----------------------------------------------------------------------
function SkeletonPostItem() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        sm: 6,
        md: 3,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                width: "100%",
                sx: {
                    height: 200,
                    borderRadius: 2
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    display: "flex",
                    mt: 1.5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "circular",
                        sx: {
                            width: 40,
                            height: 40
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "text",
                        sx: {
                            mx: 1,
                            flexGrow: 1
                        }
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack_Stack = __webpack_require__(26447);
;// CONCATENATED MODULE: ./src/components/skeleton/SkeletonProductItem.tsx
// @mui


// ----------------------------------------------------------------------
function SkeletonProductItem() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                sx: {
                    paddingTop: "100%"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 2,
                sx: {
                    p: 3
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "text",
                        sx: {
                            width: 0.5
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                        variant: "circular",
                                        sx: {
                                            width: 16,
                                            height: 16
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                        variant: "circular",
                                        sx: {
                                            width: 16,
                                            height: 16
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                        variant: "circular",
                                        sx: {
                                            width: 16,
                                            height: 16
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "text",
                                sx: {
                                    width: 40
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/skeleton/SkeletonKanbanColumn.tsx
// @mui



// ----------------------------------------------------------------------
function SkeletonKanbanColumn() {
    return /*#__PURE__*/ _jsx(Box, {
        sx: {
            display: "grid",
            gap: 3,
            gridTemplateColumns: "repeat(4, 1fr)"
        },
        children: _to_consumable_array(Array(3)).map(function(_, index) {
            return /*#__PURE__*/ _jsx(Paper, {
                variant: "outlined",
                sx: {
                    p: 2.5,
                    width: 310
                },
                children: /*#__PURE__*/ _jsxs(Stack, {
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ _jsx(Skeleton, {
                            variant: "rectangular",
                            sx: {
                                paddingTop: "75%",
                                borderRadius: 1.5
                            }
                        }),
                        index === 0 && /*#__PURE__*/ _jsx(Skeleton, {
                            variant: "rectangular",
                            sx: {
                                paddingTop: "25%",
                                borderRadius: 1.5
                            }
                        }),
                        index !== 2 && /*#__PURE__*/ _jsx(Skeleton, {
                            variant: "rectangular",
                            sx: {
                                paddingTop: "25%",
                                borderRadius: 1.5
                            }
                        })
                    ]
                })
            }, index);
        })
    });
}

;// CONCATENATED MODULE: ./src/components/skeleton/SkeletonMailSidebarItem.tsx
// @mui


// ----------------------------------------------------------------------
function SkeletonMailSidebarItem() {
    return /*#__PURE__*/ _jsxs(Stack, {
        spacing: 1,
        direction: "row",
        alignItems: "center",
        sx: {
            px: 3,
            py: 1
        },
        children: [
            /*#__PURE__*/ _jsx(Skeleton, {
                variant: "circular",
                width: 32,
                height: 32
            }),
            /*#__PURE__*/ _jsx(Skeleton, {
                variant: "text",
                sx: {
                    width: 0.25,
                    height: 16
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/skeleton/SkeletonConversationItem.tsx
// @mui


// ----------------------------------------------------------------------
function SkeletonConversationItem() {
    return /*#__PURE__*/ _jsxs(Stack, {
        spacing: 1,
        direction: "row",
        alignItems: "center",
        sx: {
            px: 3,
            py: 1.5
        },
        children: [
            /*#__PURE__*/ _jsx(Skeleton, {
                variant: "circular",
                width: 48,
                height: 48
            }),
            /*#__PURE__*/ _jsxs(Stack, {
                spacing: 0.5,
                sx: {
                    flexGrow: 1
                },
                children: [
                    /*#__PURE__*/ _jsx(Skeleton, {
                        variant: "text",
                        sx: {
                            width: 0.5,
                            height: 16
                        }
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        variant: "text",
                        sx: {
                            width: 0.25,
                            height: 12
                        }
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/skeleton/SkeletonImage.tsx
var SkeletonImage = __webpack_require__(50853);
;// CONCATENATED MODULE: ./src/components/skeleton/index.ts











/***/ }),

/***/ 16225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jy": function() { return /* reexport */ PostBody; },
  "Gg": function() { return /* reexport */ BlogPostCard; },
  "pi": function() { return /* reexport */ BlogPostHero; },
  "_Y": function() { return /* reexport */ BlogPostRecent; },
  "j6": function() { return /* reexport */ BlogPostTags; },
  "cO": function() { return /* reexport */ BlogPostsSort; }
});

// UNUSED EXPORTS: BlogPostsSearch

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(40549);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(94581);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(69661);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(36822);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(44267);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography_Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 1 modules
var Link_Link = __webpack_require__(50122);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./src/hooks/useResponsive.ts
var useResponsive = __webpack_require__(10653);
// EXTERNAL MODULE: ./src/utils/formatTime.ts
var formatTime = __webpack_require__(69127);
// EXTERNAL MODULE: ./src/components/Image.tsx
var components_Image = __webpack_require__(97349);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
;// CONCATENATED MODULE: ./src/utils/getFontValue.ts
// @mui


// hooks

// ----------------------------------------------------------------------
function GetFontValue(variant) {
    var theme = (0,useTheme/* default */.Z)();
    var breakpoints = useWidth();
    var key = theme.breakpoints.up(breakpoints === "xl" ? "lg" : breakpoints);
    var hasResponsive = variant === "h1" || variant === "h2" || variant === "h3" || variant === "h4" || variant === "h5" || variant === "h6";
    var getFont = hasResponsive && theme.typography[variant][key] ? theme.typography[variant][key] : theme.typography[variant];
    var fontSize = remToPx(getFont.fontSize);
    var lineHeight = Number(theme.typography[variant].lineHeight) * fontSize;
    var _variant = theme.typography[variant], fontWeight = _variant.fontWeight, letterSpacing = _variant.letterSpacing;
    return {
        fontSize: fontSize,
        lineHeight: lineHeight,
        fontWeight: fontWeight,
        letterSpacing: letterSpacing
    };
}
// ----------------------------------------------------------------------
function remToPx(value) {
    return Math.round(parseFloat(value) * 16);
}
function pxToRem(value) {
    return "".concat(value / 16, "rem");
}
function responsiveFontSizes(param) {
    var sm = param.sm, md = param.md, lg = param.lg;
    return {
        "@media (min-width:600px)": {
            fontSize: pxToRem(sm)
        },
        "@media (min-width:900px)": {
            fontSize: pxToRem(md)
        },
        "@media (min-width:1200px)": {
            fontSize: pxToRem(lg)
        }
    };
}
// ----------------------------------------------------------------------
function useWidth() {
    var theme = (0,useTheme/* default */.Z)();
    var keys = (0,_to_consumable_array/* default */.Z)(theme.breakpoints.keys).reverse();
    return(// @ts-ignore not sure what is this
    keys.reduce(function(output, key) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var matches = (0,useResponsive/* default */.Z)("up", key);
        return !output && matches ? key : output;
    }, null) || "xs");
}

;// CONCATENATED MODULE: ./src/components/TextMaxLine.tsx






// utils

var TextMaxLine = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var asLink = _param.asLink, _variant = _param.variant, variant = _variant === void 0 ? "body1" : _variant, _line = _param.line, line = _line === void 0 ? 2 : _line, _persistent = _param.persistent, persistent = _persistent === void 0 ? false : _persistent, children = _param.children, sx = _param.sx, other = (0,src_object_without_properties/* default */.Z)(_param, [
        "asLink",
        "variant",
        "line",
        "persistent",
        "children",
        "sx"
    ]);
    var lineHeight = GetFontValue(variant).lineHeight;
    var style = (0,src_object_spread/* default */.Z)({
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitLineClamp: line,
        WebkitBoxOrient: "vertical"
    }, persistent && {
        height: lineHeight * line
    }, sx);
    if (asLink) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_Link/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            color: "inherit",
            ref: ref,
            variant: variant,
            sx: (0,src_object_spread/* default */.Z)({}, style)
        }, other), {
            children: children
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        ref: ref,
        variant: variant,
        sx: (0,src_object_spread/* default */.Z)({}, style)
    }, other), {
        children: children
    }));
});
/* harmony default export */ var components_TextMaxLine = (TextMaxLine);

// EXTERNAL MODULE: ./src/components/SvgIconStyle.tsx
var SvgIconStyle = __webpack_require__(58432);
// EXTERNAL MODULE: ./src/components/Label.tsx
var Label = __webpack_require__(4930);
;// CONCATENATED MODULE: ./src/sections/blog/BlogPostCard.tsx
// next




// @mui


// hooks

// utils

// components




// ----------------------------------------------------------------------
var OverlayStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return {
        top: 0,
        zIndex: 1,
        width: "100%",
        height: "100%",
        position: "absolute",
        backgroundColor: (0,colorManipulator/* alpha */.Fq)(theme.palette.grey[900], 0.8),
        transition: "background-color 0.3s",
        ":hover": {
            backgroundColor: "transparent"
        }
    };
});
function BlogPostCard(param) {
    var post = param.post, index = param.index, _showCategory = param.showCategory, showCategory = _showCategory === void 0 ? true : _showCategory, onClick = param.onClick;
    var isDesktop = (0,useResponsive/* default */.Z)("up", "md");
    var ref = (0,router.useRouter)(), push = ref.push, locale = ref.locale;
    var title = post.title, previewUrl = post.previewUrl, coverUrl = post.coverUrl, author = post.author, publishedAt = post.publishedAt, categories = post.categories;
    var latestPost = index === 0 || index === 1 || index === 2;
    var linkTo = "/post/".concat(encodeURIComponent(title));
    var handleRouterPush = function(path) {
        var ref;
        (ref = onClick === null || onClick === void 0 ? void 0 : onClick(post)) !== null && ref !== void 0 ? ref : push({
            pathname: path
        }, undefined, {
            locale: locale
        });
    };
    if (isDesktop && latestPost) {
        var _profileImage, ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
            onClick: function() {
                handleRouterPush(linkTo);
            },
            sx: {
                cursor: "pointer"
            },
            children: [
                showCategory && categories[0] && /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                    variant: "filled",
                    color: "error",
                    sx: {
                        zIndex: 9,
                        top: 16,
                        right: 16,
                        position: "absolute"
                    },
                    children: categories[0]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                    alt: author.name,
                    src: (_profileImage = author.profileImage) !== null && _profileImage !== void 0 ? _profileImage : "",
                    sx: {
                        zIndex: 9,
                        top: 24,
                        left: 24,
                        width: 40,
                        height: 40,
                        position: "absolute"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostContent, {
                    title: title,
                    publishedAt: publishedAt,
                    index: index,
                    linkTo: linkTo
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayStyle, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Image/* default */.Z, {
                    alt: "cover",
                    src: (ref1 = previewUrl !== null && previewUrl !== void 0 ? previewUrl : coverUrl) !== null && ref1 !== void 0 ? ref1 : "",
                    sx: {
                        height: 360
                    }
                })
            ]
        });
    }
    var _profileImage1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        onClick: function() {
            handleRouterPush(linkTo);
        },
        sx: {
            cursor: "pointer"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIconStyle/* default */.Z, {
                        src: "https://minimal-assets-api.vercel.app/assets/icons/shape-avatar.svg",
                        sx: {
                            width: 80,
                            height: 36,
                            zIndex: 9,
                            bottom: -15,
                            position: "absolute",
                            color: "background.paper"
                        }
                    }),
                    showCategory && categories[0] && /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                        variant: "filled",
                        color: "error",
                        sx: {
                            zIndex: 9,
                            top: 16,
                            right: 16,
                            position: "absolute"
                        },
                        children: categories[0]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        alt: author.name,
                        src: (_profileImage1 = author.profileImage) !== null && _profileImage1 !== void 0 ? _profileImage1 : "",
                        sx: {
                            left: 24,
                            zIndex: 9,
                            width: 32,
                            height: 32,
                            bottom: -16,
                            position: "absolute"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Image/* default */.Z, {
                        alt: "cover",
                        src: (ref2 = previewUrl !== null && previewUrl !== void 0 ? previewUrl : coverUrl) !== null && ref2 !== void 0 ? ref2 : "",
                        ratio: "4/3"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostContent, {
                title: title,
                publishedAt: publishedAt,
                linkTo: linkTo
            })
        ]
    });
}
function PostContent(param) {
    var title = param.title, linkTo = param.linkTo, _view = param.view, view = _view === void 0 ? 0 : _view, _comment = param.comment, comment = _comment === void 0 ? 0 : _comment, _share = param.share, share = _share === void 0 ? 0 : _share, publishedAt = param.publishedAt, index = param.index;
    var isDesktop = (0,useResponsive/* default */.Z)("up", "md");
    var latestPostLarge = index === 0;
    var latestPostSmall = index === 1 || index === 2;
    var POST_INFO = [
        // { number: comment, icon: 'eva:message-circle-fill' },
        {
            number: view,
            icon: "eva:eye-fill"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
        sx: (0,src_object_spread/* default */.Z)({
            pt: 4.5,
            width: 1
        }, (latestPostLarge || latestPostSmall) && {
            pt: 0,
            zIndex: 9,
            bottom: 0,
            position: "absolute",
            color: "common.white"
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                gutterBottom: true,
                variant: "caption",
                component: "div",
                sx: (0,src_object_spread/* default */.Z)({
                    color: "text.disabled"
                }, (latestPostLarge || latestPostSmall) && {
                    opacity: 0.64,
                    color: "common.white"
                }),
                children: publishedAt && (0,formatTime/* fDate */.Mu)(publishedAt)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: linkTo,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_Link/* default */.Z, {
                    color: "inherit",
                    onClick: function(e) {
                        return e.preventDefault();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TextMaxLine, {
                        variant: isDesktop && latestPostLarge ? "h5" : "subtitle2",
                        line: 2,
                        persistent: true,
                        children: title
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                flexWrap: "wrap",
                direction: "row",
                justifyContent: "flex-end",
                sx: (0,src_object_spread/* default */.Z)({
                    mt: 3,
                    color: "text.disabled"
                }, (latestPostLarge || latestPostSmall) && {
                    opacity: 0.64,
                    color: "common.white"
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@mui/material/SpeedDial/SpeedDial.js + 2 modules
var SpeedDial = __webpack_require__(16323);
// EXTERNAL MODULE: ./node_modules/@mui/material/SpeedDialAction/SpeedDialAction.js + 1 modules
var SpeedDialAction = __webpack_require__(88075);
// EXTERNAL MODULE: ./src/components/Iconify.tsx
var components_Iconify = __webpack_require__(42445);
// EXTERNAL MODULE: ./node_modules/next-share/dist/next-share.es.js
var next_share_es = __webpack_require__(21818);
;// CONCATENATED MODULE: ./src/sections/blog/BlogPostHero.tsx
// @mui






// hooks

// utils

// components




// ----------------------------------------------------------------------
var SOCIALS = [
    {
        name: "Facebook",
        button: next_share_es/* FacebookShareButton */.Dk,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Iconify/* default */.Z, {
            icon: "eva:facebook-fill",
            width: 20,
            height: 20,
            color: "#1877F2"
        })
    },
    // {
    //   name: 'Instagram',
    //   icon: <Iconify icon="ant-design:instagram-filled" width={20} height={20} color="#D7336D" />,
    // },
    // {
    //   name: 'Linkedin',
    //   icon: <Iconify icon="eva:linkedin-fill" width={20} height={20} color="#006097" />,
    // },
    {
        name: "Twitter",
        button: next_share_es/* TwitterShareButton */.B,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Iconify/* default */.Z, {
            icon: "eva:twitter-fill",
            width: 20,
            height: 20,
            color: "#1C9CEA"
        })
    }, 
];
var BlogPostHero_OverlayStyle = (0,styled/* default */.ZP)("h1")(function(param) {
    var theme = param.theme;
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 9,
        position: "absolute",
        backgroundColor: (0,colorManipulator/* alpha */.Fq)(theme.palette.grey[900], 0.72)
    };
});
var TitleStyle = (0,styled/* default */.ZP)("h1")(function(param) {
    var theme = param.theme;
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, theme.typography.h2), (0,_define_property/* default */.Z)({
        top: 0,
        zIndex: 10,
        width: "100%",
        position: "absolute",
        padding: theme.spacing(3),
        color: theme.palette.common.white
    }, theme.breakpoints.up("lg"), {
        padding: theme.spacing(10)
    }));
});
var FooterStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        bottom: 0,
        zIndex: 10,
        width: "100%",
        display: "flex",
        position: "absolute",
        alignItems: "flex-end",
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(2),
        paddingBottom: theme.spacing(3),
        justifyContent: "space-between"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("sm"), {
        alignItems: "center",
        paddingRight: theme.spacing(3)
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("lg"), {
        padding: theme.spacing(10)
    }), _obj;
});
function BlogPostHero(param) {
    var post = param.post;
    var coverUrl = post.coverUrl, title = post.title, author = post.author, publishedAt = post.publishedAt;
    var isDesktop = (0,useResponsive/* default */.Z)("up", "sm");
    var _profileImage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleStyle, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TextMaxLine, {
                    line: isDesktop ? 10 : 8,
                    variant: isDesktop ? "h2" : "h3",
                    sx: {
                        fontWeight: "fontWeightMedium"
                    },
                    children: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterStyle, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                alt: author.name,
                                src: (_profileImage = author.profileImage) !== null && _profileImage !== void 0 ? _profileImage : "",
                                sx: {
                                    width: 48,
                                    height: 48
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    ml: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        sx: {
                                            color: "common.white"
                                        },
                                        children: author.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        sx: {
                                            color: "grey.500"
                                        },
                                        children: publishedAt && (0,formatTime/* fDate */.Mu)(publishedAt)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SpeedDial/* default */.Z, {
                        direction: isDesktop ? "left" : "up",
                        ariaLabel: "Share post",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Iconify/* default */.Z, {
                            icon: "eva:share-fill",
                            sx: {
                                width: 20,
                                height: 20
                            }
                        }),
                        sx: {
                            "& .MuiSpeedDial-fab": {
                                width: 48,
                                height: 48
                            }
                        },
                        children: SOCIALS.map(function(action) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SpeedDialAction/* default */.Z, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(action.button, {
                                    url:  true && window.location.href ? window.location.href : "",
                                    style: {
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    },
                                    children: action.icon
                                }),
                                tooltipTitle: action.name,
                                tooltipPlacement: "top",
                                FabProps: {
                                    color: "default"
                                }
                            }, action.name);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogPostHero_OverlayStyle, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Image/* default */.Z, {
                alt: "post cover",
                src: coverUrl !== null && coverUrl !== void 0 ? coverUrl : "",
                ratio: isDesktop ? "16/9" : "4/6"
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Chip/Chip.js + 2 modules
var Chip = __webpack_require__(99062);
;// CONCATENATED MODULE: ./src/sections/blog/BlogPostTags.tsx
// @mui


function BlogPostTags(param) {
    var post = param.post;
    var tags = post.tags;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            py: 3
        },
        children: tags.map(function(tag) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                label: tag,
                sx: {
                    m: 0.5
                }
            }, tag);
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 3 modules
var TextField = __webpack_require__(41997);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(18972);
;// CONCATENATED MODULE: ./src/sections/blog/BlogPostsSort.tsx
// @mui


function BlogPostsSort(param) {
    var query = param.query, options = param.options, onSort = param.onSort;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
        select: true,
        size: "small",
        value: query,
        onChange: function(event) {
            return onSort(event.target.value);
        },
        sx: {
            "& .MuiSelect-select": {
                typography: "body2"
            }
        },
        children: options.map(function(option) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                value: option.value,
                sx: {
                    typography: "body2",
                    mx: 1,
                    my: 0.5,
                    borderRadius: 0.75
                },
                children: option.label
            }, option.value);
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
;// CONCATENATED MODULE: ./src/sections/blog/BlogPostRecent.tsx
// @mui


//

function BlogPostRecent(param) {
    var posts = param.posts;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h4",
                sx: {
                    mt: 10,
                    mb: 5
                },
                children: "Recent posts"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                spacing: 3,
                children: posts.map(function(post) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        md: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogPostCard, {
                            post: post
                        })
                    }, post.id);
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/autosuggest-highlight/parse/index.js
var autosuggest_highlight_parse = __webpack_require__(23370);
// EXTERNAL MODULE: ./node_modules/autosuggest-highlight/match/index.js
var autosuggest_highlight_match = __webpack_require__(11447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Popper/Popper.js + 55 modules
var Popper = __webpack_require__(60485);
// EXTERNAL MODULE: ./src/hooks/useIsMountedRef.ts
var hooks_useIsMountedRef = __webpack_require__(60128);
// EXTERNAL MODULE: ./src/utils/axios.ts
var utils_axios = __webpack_require__(21744);
// EXTERNAL MODULE: ./src/routes/paths.ts
var paths = __webpack_require__(96259);
;// CONCATENATED MODULE: ./src/components/InputStyle.tsx
// @mui




var InputStyle_InputStyle = (0,styled/* default */.ZP)(TextField/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "stretchStart";
    }
})(function(param) {
    var stretchStart = param.stretchStart, theme = param.theme;
    return {
        "& .MuiOutlinedInput-root": (0,src_object_spread/* default */.Z)({
            transition: theme.transitions.create([
                "box-shadow",
                "width"
            ], {
                easing: theme.transitions.easing.easeInOut,
                duration: theme.transitions.duration.shorter
            }),
            "&.Mui-focused": {
                boxShadow: theme.customShadows.z12
            }
        }, stretchStart && {
            width: stretchStart,
            "&.Mui-focused": (0,_define_property/* default */.Z)({
                boxShadow: theme.customShadows.z12
            }, theme.breakpoints.up("sm"), {
                width: stretchStart + 60
            })
        }),
        "& fieldset": {
            borderWidth: "1px !important",
            borderColor: "".concat(theme.palette.grey[50032], " !important")
        }
    };
});
/* harmony default export */ var components_InputStyle = ((/* unused pure expression or super */ null && (InputStyle_InputStyle)));

;// CONCATENATED MODULE: ./src/components/SearchNotFound.tsx





function SearchNotFound_SearchNotFound(_param) {
    var _searchQuery = _param.searchQuery, searchQuery = _searchQuery === void 0 ? "" : _searchQuery, other = _object_without_properties(_param, [
        "searchQuery"
    ]);
    return searchQuery ? /*#__PURE__*/ _jsxs(Paper, _object_spread_props(_object_spread({}, other), {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                gutterBottom: true,
                align: "center",
                variant: "subtitle1",
                children: "Not found"
            }),
            /*#__PURE__*/ _jsxs(Typography, {
                variant: "body2",
                align: "center",
                children: [
                    "No results found for \xa0",
                    /*#__PURE__*/ _jsxs("strong", {
                        children: [
                            '"',
                            searchQuery,
                            '"'
                        ]
                    }),
                    ". Try checking for typos or using complete words."
                ]
            })
        ]
    })) : /*#__PURE__*/ _jsx(Typography, {
        variant: "body2",
        children: " Please enter keywords"
    });
}

;// CONCATENATED MODULE: ./src/sections/blog/BlogPostsSearch.tsx









// next

// @mui


// hooks

// utils

// routes

// components




// ----------------------------------------------------------------------
var PopperStyle = (0,styled/* default */.ZP)(function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Popper/* default */.Z, (0,src_object_spread/* default */.Z)({
        placement: "bottom-start"
    }, props));
})({
    width: "280px !important"
});
// ----------------------------------------------------------------------
function BlogPostsSearch() {
    var push = useRouter().push;
    var isMountedRef = useIsMountedRef();
    var ref = useState(""), searchQuery = ref[0], setSearchQuery = ref[1];
    var ref1 = useState([]), searchResults = ref1[0], setSearchResults = ref1[1];
    var handleChangeSearch = function() {
        var _ref = _async_to_generator(function(value) {
            var response, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        setSearchQuery(value);
                        if (!value) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            axios.get("/api/blog/posts/search", {
                                params: {
                                    query: value
                                }
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (isMountedRef.current) {
                            setSearchResults(response.data.results);
                        }
                        _state.label = 2;
                    case 2:
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error(error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleChangeSearch(value) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClick = function(title) {
        push("".concat(PATH_DASHBOARD.blog.root, "/post/").concat(paramCase(title)));
    };
    var handleKeyUp = function(event) {
        if (event.key === "Enter") {
            handleClick(searchQuery);
        }
    };
    return /*#__PURE__*/ _jsx(Autocomplete, {
        size: "small",
        autoHighlight: true,
        popupIcon: null,
        PopperComponent: PopperStyle,
        options: searchResults,
        onInputChange: function(event, value) {
            return handleChangeSearch(value);
        },
        getOptionLabel: function(post) {
            return post.title;
        },
        noOptionsText: /*#__PURE__*/ _jsx(SearchNotFound, {
            searchQuery: searchQuery
        }),
        isOptionEqualToValue: function(option, value) {
            return option.id === value.id;
        },
        renderInput: function(params) {
            return /*#__PURE__*/ _jsx(InputStyle, _object_spread_props(_object_spread({}, params), {
                stretchStart: 200,
                placeholder: "Search post...",
                onKeyUp: handleKeyUp,
                InputProps: _object_spread_props(_object_spread({}, params.InputProps), {
                    startAdornment: /*#__PURE__*/ _jsx(InputAdornment, {
                        position: "start",
                        children: /*#__PURE__*/ _jsx(Iconify, {
                            icon: "eva:search-fill",
                            sx: {
                                ml: 1,
                                width: 20,
                                height: 20,
                                color: "text.disabled"
                            }
                        })
                    })
                })
            }));
        },
        renderOption: function(props, post, param) {
            var inputValue = param.inputValue;
            var title = post.title, cover = post.cover;
            var matches = match(title, inputValue);
            var parts = parse(title, matches);
            return /*#__PURE__*/ _jsxs("li", _object_spread_props(_object_spread({}, props), {
                children: [
                    /*#__PURE__*/ _jsx(Image, {
                        alt: cover,
                        src: cover,
                        sx: {
                            width: 48,
                            height: 48,
                            borderRadius: 1,
                            flexShrink: 0,
                            mr: 1.5
                        }
                    }),
                    /*#__PURE__*/ _jsx(Link, {
                        underline: "none",
                        onClick: function() {
                            return handleClick(title);
                        },
                        children: parts.map(function(part, index) {
                            return /*#__PURE__*/ _jsx(Typography, {
                                component: "span",
                                variant: "subtitle2",
                                color: part.highlight ? "primary" : "textPrimary",
                                children: part.text
                            }, index);
                        })
                    })
                ]
            }));
        }
    });
}

// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-react-renderer/dist/rich-text-react-renderer.es5.js
var rich_text_react_renderer_es5 = __webpack_require__(74129);
// EXTERNAL MODULE: ./src/components/contentful/Shared.tsx
var Shared = __webpack_require__(41923);
;// CONCATENATED MODULE: ./src/sections/blog/BlogPostBody.tsx



function PostBody(param) {
    var content = param.content;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "max-w-2xl mx-auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared/* RichTextStyleWrapper */.w, {
            children: (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(content === null || content === void 0 ? void 0 : content.json, (0,Shared/* renderOptionFunc */.Z)(content === null || content === void 0 ? void 0 : (ref = content.links) === null || ref === void 0 ? void 0 : ref.assets))
        })
    });
}

;// CONCATENATED MODULE: ./src/sections/blog/index.ts









/***/ }),

/***/ 20474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ notEmpty; }
/* harmony export */ });
var notEmpty = function(value) {
    return value !== null && value !== undefined;
};


/***/ })

}]);